<template>
  <div class="modal" id="modal-add-credit-notes" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-sm" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add a Credit Note</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <form @submit.prevent="addCreditNote">
          <div class="modal-body">

            <div class="form-group row mb-0">
              <label class="col-sm-2 col-form-label required" for="input-credit-note-code">Code</label>
              <div class="col-sm-10">
                <input type="text" class="form-control" id="input-credit-note-code" name="code" v-model="code" maxlength="10" tabindex="1" required>
              </div>
            </div>

          </div>
          <div class="modal-footer">
            <button type="button" data-dismiss="modal" class="btn btn-secondary">Close</button>
            <button type="submit" class="btn btn-primary" :disabled="!code || processing">
              <i v-if="processing" class="fas fa-circle-notch fa-spin"></i>
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import jQuery from 'jquery'

export default {
  name: 'CreditNotes',
  data () {
    return {
      processing: false,
      code: null
    }
  },
  methods: {
    addCreditNote () {
      if (!this.code) {
        this.$toast.error('Please provide the credit note code')
        return
      }

      let postData = {
        code: this.code,
        include_cart: true
      }

      this.processing = true

      axios.post(process.env.URLS_PUBLIC_API + '/cart/' + this.$parent.cart.id + '/credit_notes', postData).then((response) => {
        this.$parent.cart = response.data.data.cart

        this.code = null

        jQuery('#modal-add-credit-notes').modal('hide')

        setTimeout(() => {
          this.$parent.setPaneHeights()
        }, 100)
      }).catch(error => {
        this.$toast.error('Failed to add the credit note.' + typeof error.response !== 'undefined' && typeof error.response.data.message !== 'undefined' ? error.response.data.message : null)
      }).finally(() => {
        this.processing = false
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sale/partials/CreditNotes.vue